const localStore = {

  setItem(key, value) {
    try {
      localStorage.setItem(key, JSON.stringify(value));
      return key;
    } catch (e) {
      return null;
    }
  },

  getItem(key) {
    try {
      return JSON.parse(localStorage.getItem(key));
    } catch (e) {
      return null;
    }
  },

  removeItem(key) {
    try {
      localStorage.removeItem(key);
      return key;
    } catch (e) {
      return null;
    }
  },

  clear() {
    try {
      localStorage.clear();
      return 'Success';
    } catch (e) {
      return null;
    }
  },

};

export default localStore;
